"use client";
import { createContext, useContext, useState } from "react";

type ModalType = "privacy" | "terms" | "security" | null;

interface ModalContextType {
  openModal: (type: ModalType) => void;
  closeModal: () => void;
  modalType: ModalType;
}

const LegalModalContext = createContext<ModalContextType | null>(null);

export function LegalModalProvider({ children }: { children: React.ReactNode }) {
  const [modalType, setModalType] = useState<ModalType>(null);

  const openModal = (type: ModalType) => setModalType(type);
  const closeModal = () => setModalType(null);

  return (
    <LegalModalContext.Provider value={{ openModal, closeModal, modalType }}>
      {children}
    </LegalModalContext.Provider>
  );
}

export function useLegalModal() {
  const ctx = useContext(LegalModalContext);
  if (!ctx) throw new Error("useLegalModal must be inside LegalModalProvider");
  return ctx;
}
